module.exports = __webpack_public_path__ + "static/esperanzazama_1-047c79a447b9970c48753f349bdebc62.jpg";